import React from "react"
import { Container, Header, Left, Right, Tab, Search, Body, ErrorBody, NotFoundText, NoDataFound } from "./styles/accordion"
import { Container as MainContainer } from "../../containers"

export default function Accordion({ children, ...rest }) {
  return (
    <MainContainer>
      <Container {...rest}>{children}</Container>
    </MainContainer>
  )
}

Accordion.Header = function AccordionHeader({ children, ...rest }) {
  return <Header {...rest}>{children}</Header>
}

Accordion.Left = function AccordionLeft({ children, ...rest }) {
  return <Left {...rest}>{children}</Left>
}

Accordion.Right = function AccordionRight({ children, ...rest }) {
  return <Right {...rest}>{children}</Right>
}

Accordion.Tab = function AccordionTab({ children, active, ...rest }) {
  return (
    <Tab {...rest} active={active}>
      {children}
    </Tab>
  )
}

Accordion.Search = function AccordionSearch({ children, ...rest }) {
  return <Search {...rest} placeholder="Find" />
}

Accordion.Body = function AccordionBody({ children, ...rest }) {
  return <Body {...rest}>{children}</Body>
}

Accordion.ErrorBody = function AccordionErrorBody({ children, ...rest }) {
  return <ErrorBody {...rest}>{children}</ErrorBody>
}

Accordion.NotFoundText = function AccordionNotFoundText({ children, ...rest }) {
  return <NotFoundText {...rest}>{children}</NotFoundText>
}

Accordion.NoDataFound = function AccordionNoDataFound({ children, ...rest }) {
  return <NoDataFound {...rest}>{children}</NoDataFound>
}
